/*
 * menu-trigger btn
 * ----------------------------------------------- */
(function () {
  var $menuTrigger = $(".menu-trigger");
  var $navCollapseMain = $(".nav-collapse-main");
  var $linkReturn = $(".link-return");
  var linkUtilization = $(".link-utilization");
  var linkProduct = $(".link-product");
  var linkSearch = $(".link-search");

  $menuTrigger.on("click", function (e) {
    $(this).toggleClass("active");
    $navCollapseMain.toggleClass("open");

    $(".nav-collapse-item").removeClass("open");
    $("#modalArea").fadeOut();
  });


  $linkReturn.on("click", function (e) {
    $(".nav-collapse-item").removeClass("open");
    $("#modalArea").fadeOut();
  });

  linkUtilization.on("click", function (e) {
    $(".utilization-collapse").addClass("open");
  });

  linkProduct.on("click", function (e) {
    $(".product-collapse").addClass("open");
  });

  linkSearch.on("click", function (e) {
    $(".search-collapse").addClass("open");
    $("#modalArea").fadeIn();
  });
})();
